import { styled } from "@mui/material/styles";
// import { lighten } from "@mui/system";

export const Wrapper = styled("div")(({ theme }) => ({
  gridArea: "dashboardInvestor",
  width: "100%",
  overflowY: "scroll",

  display: "flex",
  justifyContent: "center",
  padding: "25px 10px 0 10px",
  [theme.breakpoints.up("md")]: {
    padding: "25px 10px 0 15px",
  },
  color: theme.palette.primary.main,
}));
